module.exports = __webpack_public_path__ + "static/media/video-2.3fc7fd3d.png";